'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var styled = require('styled-components');
var nthHookTranslations = require('@narvar/nth-hook-translations');
var Paragraph = require('@narvar/nth-bit-paragraph');
var Button = require('@narvar/nth-block-button');
var Drawer = require('../../components/layout/Drawer.js');
var MobileDrawerItemDetails = require('../../components/MobileDrawerItemDetails.js');
var index = require('../../providers/ClaimBuilder/index.js');
var ErrorBanner = require('../../components/ErrorBanner.js');
var ItemPhotosList = require('./ItemPhotosList.js');
var ItemPhotosUploadButton = require('./ItemPhotosUploadButton.js');
var SecondaryButton = require('../../components/SecondaryButton.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);
var Paragraph__default = /*#__PURE__*/_interopDefaultLegacy(Paragraph);
var Button__default = /*#__PURE__*/_interopDefaultLegacy(Button);

const Container = styled__default["default"].div.withConfig({
  componentId: "sc-cwtti4-0"
})(["display:flex;flex-direction:column;align-items:center;"]);
const Spacer = styled__default["default"].div.withConfig({
  componentId: "sc-cwtti4-1"
})(["padding-bottom:1rem;"]);
const ItemPhotoMobile = _ref => {
  let {
    photos,
    itemDetails,
    claimDetails,
    onRemovePhoto,
    onChangeFile,
    onSubmit,
    onBack,
    error,
    computedTranslations,
    canProceed
  } = _ref;
  const {
    handleDismissItemClaimDetailStep
  } = index.useClaimBuilder();
  const {
    claimsButtonBack,
    claimsButtonNext,
    claimsDetailViewDismissStepItem,
    claimsPhotoUploadDescription
  } = nthHookTranslations.useTranslations();
  const {
    photoUploadTitle
  } = computedTranslations;
  return /*#__PURE__*/React__default["default"].createElement(Drawer.Drawer, {
    onDismiss: handleDismissItemClaimDetailStep,
    dismissText: claimsDetailViewDismissStepItem ?? ''
  }, /*#__PURE__*/React__default["default"].createElement(Drawer.DrawerHeader, {
    title: photoUploadTitle
  }), /*#__PURE__*/React__default["default"].createElement(Drawer.DrawerContent, null, /*#__PURE__*/React__default["default"].createElement(Container, null, /*#__PURE__*/React__default["default"].createElement(Spacer, null, /*#__PURE__*/React__default["default"].createElement("svg", {
    width: "109",
    height: "101",
    viewBox: "0 0 109 101",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M99.8146 22.7014H85.5771L83.0511 7.87211C82.5918 5.38079 81.3288 3.12674 79.2621 1.70313C77.1954 0.279518 74.7842 -0.313653 72.373 0.160884L7.6155 11.9057C2.56349 12.8547 -0.766236 17.7188 0.15231 22.9387L10.1415 81.1881C10.6008 83.6794 11.9786 85.8148 13.9305 87.3571C15.538 88.5434 17.2602 89.1366 19.2121 89.1366C19.7862 89.1366 20.3603 89.1366 20.8196 89.0179L24.8382 88.3061V91.5093C24.8382 96.7292 28.9717 101 34.0237 101H99.8146C104.867 101 109 96.7292 109 91.5093V32.3108C109 26.9722 104.867 22.7014 99.8146 22.7014ZM94.5329 43.1065C94.5329 46.4282 92.0069 49.0382 88.792 49.0382C85.5771 49.0382 83.0511 46.4282 83.0511 43.1065C83.0511 39.7847 85.5771 37.1748 88.792 37.1748C91.8921 37.1748 94.5329 39.9034 94.5329 43.1065ZM19.327 81.1881C18.7529 81.3067 18.2936 81.0694 18.1788 80.9508C17.9491 80.8322 17.6047 80.4763 17.4899 79.8831L7.6155 21.6337C7.50068 20.6846 8.07477 19.8542 8.8785 19.7355L73.636 7.87211C73.7508 7.87211 73.8656 7.87211 73.8656 7.87211C74.3249 7.87211 74.6693 8.10938 74.7842 8.22801C75.0138 8.34665 75.3583 8.70255 75.4731 9.29572L77.7694 22.82H34.0237C28.9717 22.82 24.8382 27.0909 24.8382 32.3108V80.239L19.327 81.1881ZM99.8146 93.0515H34.0237C33.1051 93.0515 32.4162 92.3397 32.4162 91.3906V75.2564L53.8872 49.75C54.4613 49.0382 55.4947 49.0382 56.0688 49.75L69.3877 65.4097C69.6173 65.647 69.7322 66.0029 69.6173 66.3588L67.8951 74.4259C67.7803 75.0191 68.4692 75.375 68.8136 74.9005L82.1325 59.8339C82.5918 59.3594 83.2807 59.3594 83.6252 59.8339L101.307 79.8831V91.3906C101.307 92.3397 100.618 93.0515 99.8146 93.0515Z",
    fill: "#999999"
  }))), /*#__PURE__*/React__default["default"].createElement(ItemPhotosUploadButton["default"], {
    onChangeFile: onChangeFile
  }), /*#__PURE__*/React__default["default"].createElement(Spacer, null, /*#__PURE__*/React__default["default"].createElement(Paragraph__default["default"], null, claimsPhotoUploadDescription)), error && /*#__PURE__*/React__default["default"].createElement(ErrorBanner["default"], null, error), /*#__PURE__*/React__default["default"].createElement(ItemPhotosList["default"], {
    photos: photos,
    onRemovePhoto: onRemovePhoto
  }))), /*#__PURE__*/React__default["default"].createElement(Drawer.DrawerFooter, null, /*#__PURE__*/React__default["default"].createElement(MobileDrawerItemDetails["default"], {
    itemDetails: itemDetails,
    claimDetails: claimDetails
  }), /*#__PURE__*/React__default["default"].createElement(Drawer.DrawerActions, null, /*#__PURE__*/React__default["default"].createElement(SecondaryButton["default"], {
    big: true,
    onClick: onBack
  }, claimsButtonBack), /*#__PURE__*/React__default["default"].createElement(Button__default["default"], {
    big: true,
    disabled: !canProceed,
    onClick: onSubmit
  }, claimsButtonNext))));
};
var ItemPhotoMobile$1 = nthHookTranslations.withTranslationsProvider(ItemPhotoMobile, {
  translationKeys: ['claimsButtonBack', 'claimsButtonNext', 'claimsDetailViewDismissStepItem', 'claimsPhotoUploadDescription']
});

exports["default"] = ItemPhotoMobile$1;
